<script>
export default {}
</script>

<template>
  <div id="containerLogin">
    <div id="blockLogin">
      <slot />
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@design';

</style>
